import React, { useEffect, useState } from "react";
import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { ExternalLink, LogOut, Wrench } from "lucide-react";
import SiteLogo from "@/components/SiteLogo";

const linkClass = ({ isActive }) =>
  `rounded-full px-4 py-2 text-sm font-medium transition-colors ${
    isActive ? "bg-[#fbd9e5] text-[#3e2723]" : "text-[#3e2723]/70 hover:bg-[#fbd9e5]/50 hover:text-[#3e2723]"
  }`;

export default function AdminLayout() {
  const navigate = useNavigate();
  const [ready, setReady] = useState(false);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const r = await fetch("/api/admin/session.php", { credentials: "include" });
        const j = await r.json();
        if (cancelled) return;
        if (!j.ok) {
          navigate("/admin/login", { replace: true });
          return;
        }
        setReady(true);
      } catch {
        if (!cancelled) navigate("/admin/login", { replace: true });
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [navigate]);

  const onLogout = async () => {
    await fetch("/api/admin/logout.php", { method: "POST", credentials: "include" }).catch(() => {});
    navigate("/admin/login", { replace: true });
  };

  if (!ready) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-[#f7f4f3] text-sm text-[#3e2723]/65">
        Se verifică accesul…
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-[#f7f4f3] text-[#3e2723]">
      <header className="sticky top-0 z-20 border-b border-[#3e2723]/10 bg-white/85 px-4 py-3 backdrop-blur-xl">
        <div className="mx-auto flex max-w-6xl flex-wrap items-center justify-between gap-3">
          <div className="flex items-center gap-3">
            <SiteLogo variant="header" />
            <span className="hidden text-xs uppercase tracking-[0.18em] text-[#3e2723]/45 sm:inline">Admin</span>
          </div>

          <nav className="flex flex-wrap items-center gap-2 rounded-full border border-[#3e2723]/10 bg-white p-1.5 shadow-sm">
            <NavLink to="/admin/dashboard" className={linkClass}>
              Dashboard
            </NavLink>
            <NavLink to="/admin/leads" className={linkClass}>
              Leads
            </NavLink>
            <NavLink to="/admin/content" className={linkClass}>
              Content
            </NavLink>
            <NavLink to="/admin/maintenance" className={linkClass}>
              <span className="inline-flex items-center gap-1.5">
                <Wrench className="h-3.5 w-3.5 opacity-80" /> Mentenanță
              </span>
            </NavLink>
            <NavLink to="/admin/json" className={linkClass}>
              JSON expert
            </NavLink>
          </nav>

          <div className="flex items-center gap-2">
            <a
              href="/"
              target="_blank"
              rel="noreferrer"
              className="hidden items-center gap-1 rounded-full border border-[#3e2723]/15 px-3 py-2 text-xs font-semibold text-[#3e2723]/70 hover:bg-white sm:inline-flex"
            >
              <ExternalLink className="h-3.5 w-3.5" /> Vezi site
            </a>
            <button
              type="button"
              onClick={onLogout}
              className="inline-flex items-center gap-1.5 rounded-full bg-[#3e2723] px-4 py-2 text-sm font-semibold text-[#fbd9e5] hover:bg-[#2a1a17]"
            >
              <LogOut className="h-3.5 w-3.5" /> Ieșire
            </button>
          </div>
        </div>
      </header>
      <main className="px-4 py-6">
        <Outlet />
      </main>
    </div>
  );
}
